import { Badge } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import styles from '../nav.module.scss'

const AuditsLink = ({ className, activeClassName, exact, to, children }) => {
  const { audit = 0 } = useSelector(
    (state) => ({
      audit: state.notifications?.counters?.audit,
    }),
    shallowEqual,
  )

  return (
    <NavLink
      className={className}
      activeClassName={activeClassName}
      exact={exact}
      to={to}
    >
      {children}
      {audit !== 0 && (
        <Badge
          className={styles['nav__link-badge']}
          bgColor={'Label-Error-Primary'}
          color={'Label-Onsurface'}
        >
          {audit}
        </Badge>
      )}
    </NavLink>
  )
}
export default AuditsLink

AuditsLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
